import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c662c82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help_index" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Help",
      menuState: "",
      skipPath: _ctx.skipPath,
      backgroundColor: "#424040",
      fontColor: "#fff"
    }, null, 8, ["skipPath"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_collapse, {
        modelValue: $setup.activeNames,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.activeNames) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.help_center, (item) => {
            return (_openBlock(), _createBlock(_component_van_collapse_item, {
              title: item.title,
              name: item.index,
              key: item.id
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.article_list, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i.id,
                    class: "first-item"
                  }, [
                    (i.class_id === item.id)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "help_item",
                          onClick: ($event: any) => ($setup.fun_junk(i.id))
                        }, _toDisplayString(i.title), 9, _hoisted_2))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["title", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}